import Glide from '@glidejs/glide';

export const PXTestimonial = (function () {
	'use strict';

	function init() {

		// don't mess with admin
		if ($('body').hasClass('wp-admin')) {
			return;
		}

		document.querySelectorAll('.pxblock--testimonial').forEach((testimonial) => {
			let glideEl = testimonial.querySelector('.glide');
			if (glideEl) {
				const glideSlides = glideEl.querySelector('.glide__slides')
				console.log(glideSlides)
				const leftArrow = glideEl.querySelector('.glide__arrow--left')
				const rightArrow = glideEl.querySelector('.glide__arrow--right')
				let glide = new Glide(glideEl, {
					type: 'carousel',
				}).mount();

				const onBefore = () => {
					const slides = glideSlides.querySelectorAll('.glide__slide')
					const bullets = glideEl.querySelectorAll('.glide__bullet')
					slides.forEach(slide => slide.setAttribute('aria-hidden', 'true'))
					bullets.forEach(bullet => bullet.removeAttribute('aria-current'))
				}
				const onAfter = () => {
					const slide = glideSlides.querySelector('.glide__slide--active')
					slide.setAttribute('aria-hidden', 'false')
					const bullet = glideEl.querySelector('.glide__bullet--active')
					bullet && bullet.setAttribute('aria-current', 'true')
				}

				glide.on('run.before', onBefore)
				glide.on('run.after', onAfter)
				onBefore()
				onAfter()
				leftArrow.addEventListener('click', (ev) => glide.go('<'))
				rightArrow.addEventListener('click', (ev) => glide.go('>'))
			}
		});
	}

	function events() { }

	return {
		init: init,
	};
})();
